if (!customElements.get('animate-text')) {
  class AnimateText extends HTMLElement {
    constructor() {
      super();

      this.words = this.textContent.split(' ');
    }

    connectedCallback() {
      this.wrapperWords();
      this.setLettersPosition();
      this.setLettersShowDelay();

      this.classList.add('animation-ready');

      this.attachEvents();
    }

    attachEvents() {
      window.addEventListener('load', this.showLetters.bind(this));

      this.lastLetterToBeDisplayed?.addEventListener('transitionend', () => {
        if (this.classList.contains('revert-position-letters')) {
          setTimeout(() => {
            this.resetAnimation();
          }, 3000);
        } else {
          this.revertLettersToDefaultPosition();
        }
      });
    }

    resetAnimation() {
      this.classList.remove('show-letters', 'revert-position-letters');

      setTimeout(() => {
        this.showLetters();
      }, 500);
    }

    revertLettersToDefaultPosition() {
      this.classList.add('revert-position-letters');
    }

    showLetters() {
      this.classList.add('show-letters');
    }

    wrapperWords() {
      let newContent = '';

      this.words.forEach((word) => {
        let letters = this.wrapperWordLetters(word);

        newContent += `<span data-word>${letters}</span>`;
      });

      this.innerHTML = newContent;
    }

    wrapperWordLetters(word) {
      const letters = word.split('');
      let newContent = '';

      letters.forEach(
        (letter) => (newContent += `<span data-letter>${letter}</span>`),
      );

      return newContent;
    }

    setLettersPosition() {
      const letters = this.querySelectorAll('[data-letter]');

      letters.forEach((letter) => {
        const horizontal = this.getRandomNumber(0, 2);
        const vertical = this.getRandomNumber(-2, 2);

        letter.style.transform = `translate(${horizontal}vw, ${vertical}vw)`;
      });
    }

    setLettersShowDelay() {
      const letters = this.querySelectorAll('[data-letter]');
      let maxDuration = 0;

      letters.forEach((letter) => {
        const delayTime = this.getRandomNumber(0, 0);

        letter.style.transitionDelay = `${delayTime}s`;

        if (delayTime > maxDuration) {
          this.lastLetterToBeDisplayed = letter;

          maxDuration = delayTime;
        }
      });
    }

    getRandomNumber(min, max) {
      return (Math.random() * (max - min + 1) + min).toFixed(1);
    }
  }

  customElements.define('animate-text', AnimateText);
}
